import styled from 'styled-components';

export const Style = styled.div`
  display: flex;
  flex-direction: column;

  .final-output {
    font-weight: 700;
    margin: 20px 0px 10px 0px;
    font-size: var(--font-size-lg);
  }

  .table-body {
    overflow-x: auto;
  }

  .row {
    display: flex;
    margin-left: 0px;
    margin-right: 0px;
    flex-wrap: nowrap;

    &.footer-row {
      overflow-x: auto;
    }

    .item {
      flex: 1;
      border-bottom: 1px solid #E8E8E8;
      padding: 8px;
      min-width: 200px;

      label {
        margin-bottom: 0px;
      }
    }

    &.header {
      border-bottom: 0px;

      .item {
        background: #F4F5F8;
      }

      span {
        font-weight: 600;
      }
    }

    &.no-borders {
      .item {
        border-bottom: 0px;
      }
    }

    &.extra-added{
      background-color: #e6f7ff;
      border: 2px solid #096dd9;
    }
  }

  .actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    justify-content: flex-end;
  }
`;
